import React from "react";
import ApplicationStep from "../ApplicationStep";

const ApplicationsSteps = (props) => {
  return (
    <>
      <ApplicationStep
        investorId={props.investorId}
        retirementDetails={props.retirementData}
        handleBeginClick={props.handleBeginClick}
        miId={props.miId}
        faiId={props.faiId}
        snId={props.snId}
        leId={props.leId}
        illutrationOpened={props.illutrationOpened}
      />
    </>
  );
};

export default ApplicationsSteps;
